import { titleize } from 'inflected';
import { ReactNode } from 'react';
import { RiVoiceprintFill } from 'react-icons/ri';
import { isSafeHttpUrl } from '@src/utils/url-utils';
import { QuotedEvidence } from './activity-feed-detail-utils';

interface QuoteCardProps {
  quote: QuotedEvidence;
}

const QuoteBody = ({ quote }: QuoteCardProps): ReactNode => (
  <>
    <div className='activity-feed-detail-quote-icon'>
      <RiVoiceprintFill />
    </div>
    <div className='activity-feed-detail-quote-body'>
      <p className='activity-feed-detail-quote-text'>&ldquo;{quote.quote}&rdquo;</p>
      <p className='activity-feed-detail-quote-source'>— {titleize(quote.sourceKind)}</p>
    </div>
  </>
);

export const QuoteCard = ({ quote }: QuoteCardProps): ReactNode => {
  // Render an anchor only when the source URL passes the scheme guard; otherwise fall back to a
  // plain <div> so the card isn't a visually clickable but inert <a target='_blank'>.
  if (!isSafeHttpUrl(quote.sourceUrl)) {
    return (
      <div className='activity-feed-detail-quote'>
        <QuoteBody quote={quote} />
      </div>
    );
  }
  return (
    <a
      className='activity-feed-detail-quote'
      href={quote.sourceUrl}
      target='_blank'
      rel='noopener noreferrer'
    >
      <QuoteBody quote={quote} />
    </a>
  );
};
